import { useEffect, useState } from "react";

import { useStore } from "@nanostores/react";
import { $organizationId } from "@vega-api/custom/stores/organisations.store";
import {
  getGetAllPermissionsForCurrentUserQueryKey,
  useGetAllPermissionsForCurrentUser,
  useGetRolesNew,
} from "@vega-api/generated/auth-permission-v1/auth-permission-v1";
import { type UserPermissionEntry } from "@vega-api/generated/types/userPermissionEntry";

export const useCurrentUserRolePermission = () => {
  const organizationId = useStore($organizationId);
  const [permissionKey] = getGetAllPermissionsForCurrentUserQueryKey();
  const [manageablePermissions, setManageablePermissions] = useState<
    UserPermissionEntry[]
  >([]);
  const { isLoading: isRolesLoading, isFetched: isRolesFetched } =
    useGetRolesNew();

  const {
    data: currentUserPermissionsData,
    isLoading: isCurrentUserPermissionsLoading,
    isFetched: isCurrentUserPermissionsFetched,
  } = useGetAllPermissionsForCurrentUser({
    query: {
      queryKey: [permissionKey, organizationId],
      select: (response) => response.entries,
    },
  });

  useEffect(() => {
    if (currentUserPermissionsData) {
      const manageable = currentUserPermissionsData.filter(
        (permission) => permission.manageable,
      );
      setManageablePermissions(manageable);
    }
  }, [currentUserPermissionsData]);

  return {
    isFetched: isCurrentUserPermissionsFetched && isRolesFetched,
    isLoading: isCurrentUserPermissionsLoading || isRolesLoading,
    currentUserPermissions: currentUserPermissionsData || [],
    manageablePermissions,
  };
};
